import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import appConfig from '@nerdwallet/app-config';
import withExpandable from '@nerdwallet/react-with-expandable';

import { Box, Stack, Body, Type, Link, Card } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import LinkedInIcon from './linkedin-icon';

import styles from './people.module.less';

const CompanyPeopleExpandable = ({
  blurb,
  copy,
  expanded,
  expandable,
  experience,
  featuredIn,
  imageMobile,
  imageAlt,
  isSpecialist,
  jobTitle,
  linkedInLink,
  specialties,
  title,
}) => {
  const downArrow = <div className={styles.downArrow}>⌃</div>;
  const featuredInProcessed = (
    <React.Fragment>
      <strong>Featured in: </strong> {featuredIn}
    </React.Fragment>
  );
  const linkedInAria = `Find ${title} on LinkedIn`;
  const linkedInOutput = (
    <Box className={styles.socialLinks}>
      <Link
        href={linkedInLink}
        className={styles.linkedInLink}
        aria-label={linkedInAria}
      >
        <LinkedInIcon />
      </Link>
    </Box>
  );

  return (
    <Card primary component="div" className={styles.expandableContainer}>
      <button {...expandable.toggle} type="button">
        <Box
          alignItems="center"
          display="flex"
          justifyContent="space-between"
          width="100"
        >
          {imageMobile && (
            <Image
              alt={imageAlt}
              className={styles.mobileImage}
              naturalWidth={65}
              naturalHeight={65}
              placeholdercolor="transparent"
              src={`${appConfig.ASSETS_URL}/${imageMobile}`}
              lazy
            />
          )}
          <Box align="left" marginX="3" className={styles.expandableHeader}>
            {title && (
              <Body size="normal" bold className={styles.textFormatting}>
                {title}
              </Body>
            )}
            {!isSpecialist && jobTitle && (
              <Type size="1" gotham>
                {jobTitle}
              </Type>
            )}
            {isSpecialist && blurb && (
              <Type size="1" color="neutral-darker" gotham>
                {blurb}
              </Type>
            )}
          </Box>
          <Type color="neutral-light" size="3" gotham>
            {expanded ? `⌃` : downArrow}
          </Type>
        </Box>
      </button>
      <div
        {...expandable.region}
        className={classNames(styles.expandable, {
          [styles.expanded]: expanded,
          [styles.collapsed]: !expanded,
        })}
      >
        <Stack spacing="2" className={styles.peopleInfoStack}>
          <Type
            size="2"
            color="neutral-darkest"
            gotham
            className={styles.copyText}
          >
            {copy}
          </Type>
          {isSpecialist && experience && (
            <Type size="2" gotham>
              <strong>Experience:</strong> {experience}
            </Type>
          )}
          {isSpecialist && specialties && (
            <Type size="2" gotham>
              <strong>Specialties:</strong> {specialties}
            </Type>
          )}
          {isSpecialist && featuredIn && (
            <Type size="2" gotham className={styles.specialistStackItem}>
              {featuredInProcessed}
            </Type>
          )}
          {linkedInLink && linkedInOutput}
        </Stack>
      </div>
    </Card>
  );
};

CompanyPeopleExpandable.displayName = 'CompanyPeopleExpandable';
CompanyPeopleExpandable.propTypes = {
  ...withExpandable.propTypes,
  isSpecialist: PropTypes.bool,
};

export default withExpandable(CompanyPeopleExpandable);
